import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	PlaylistEmpty: {
		k: "playlist.empty.title",
		v: "No playlist Found"
	},
	PlaylistEmptyDescription: {
		k: "playlist.empty.description",
		v: "Add a Article to Playlist to begin"
	}
});



// WEBPACK FOOTER //
// ./src/panels/favorites/Playlist.labels.ts